export class Dealership {
    id?: string;
    name: string;
    email: string;
    address: string;
    phone: string;

    constructor(dealership) {
        if (dealership.id) { this.id = dealership.id; }
        this.name = dealership.name;
        this.email = dealership.email;
        this.address = dealership.address;
        this.phone = dealership.phone;
    }
}
